import { render, staticRenderFns } from "./ModalOrder.vue?vue&type=template&id=3a685886&"
import script from "./ModalOrder.vue?vue&type=script&lang=js&"
export * from "./ModalOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports